import moment from "moment";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { db } from "../components/Firebase";

const NotesDetails = () => {
  const [notification, setNotification] = useState([]);
  const mapArray = () => {
    const arr = notification.map((a) => {
      return { value: a, label: a };
    });
    return arr;
  };
  const [data, setData] = useState([
    {
      value: "In-Process",
      label: "In-Process",
    },
    {
      value: "Reviewed",
      label: "Reviewed",
    },
  ]);
  const [user, setUser] = useState(null);
  let location = useLocation();
  const { item } = location.state;
  const getUsers = () => {
    db.collection("user")
      .doc(item.userId)
      .get()
      .then((e) => {
        setUser({ ...e.data() });
      });
    // //console.log("dfds", user);
  };
  useEffect(() => {
    db.collection("status")
      .get()
      .then((docs) => {
        let data = [];
        docs.forEach((i) => {
          data = i.data().status;
        });
        setNotification([...data]);
      });
  }, []);
  useEffect(() => {
    getUsers();
  }, [item]);

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      width: 200,
      borderBottom: "1px dotted pink",
      color: "black",
      padding: 10,
      fontSize: 10,
    }),

    control: (_, { selectProps: { width } }) => ({
      width: width,
      display: "flex",
      backgroundColor: "white",
      borderRadius: 15,

      fontSize: 12,
      maxWidth: "100%",
      marginLeft: 10,
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 100ms";

      return { ...provided, opacity, transition };
    },
  };

  // useEffect(() => {
  //   return () => {

  // }, [item.id]);

  const statusUpdated = (status) => {
    db.collection("notes")
      .doc(item.userId)
      .collection("notes")
      .doc(item.id)
      .update({
        status,
      })
      .then(() => {
        window.location.reload(false);
      });
  };

  return (
    <ul>
  <li><strong>Name: </strong>{user?.firstName}</li>
  <li><strong>Email: </strong>{user?.email}</li>
  <li><strong>Title: </strong>{item?.title}</li>
  <li><strong>Content: </strong>{item?.content}</li>
  <li><strong>Date: </strong>{item?.createdAt}</li>
  <li><strong>Status: </strong><Select class="form-control" placeholder={item.status} onChange={(status) => statusUpdated(status.label)} options={mapArray()} /></li>
  
</ul>
  );
};

export default NotesDetails;
